import InvestmentCardWhite from './InvestmentCardWhite';

export default InvestmentCardWhite;
